(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-before-after"] && !window.DesignMode) return;
  try {
    
  class KsImageCompare extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScript()

      setTimeout(() => {
        this.querySelectorAll('[data-image-compare]').forEach(elem => {
          const viewer = new ImageCompare(elem, {
            controlColor: this.dataset.icvControlsColor,
            controlShadow: true,
            addCircle: this.dataset.icvControlsCircle === 'true',
            addCircleBlur: true,
            showLabels: this.dataset.icvShowLabels === 'true',
            labelOptions: {
              before: this.dataset.icvLabelBefore,
              after: this.dataset.icvLabelAfter,
              onHover: false
            },
            smoothing: this.dataset.icvSmoothing === 'true',
            smoothingAmount: 100,
            hoverStart: this.dataset.icvHoverStart === 'true',
            verticalMode: this.dataset.icvVerticalMode === 'true',
            startingPoint: Number(this.dataset.icvStartingPoint),
            fluidMode: false
          }).mount()
        })
      }, 500)
    }

    async injectVendorScript () {
      if (!window.ImageCompare) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/image-compare-viewer@1.5.0/dist/image-compare-viewer.min.js')
        script.setAttribute('integrity', 'sha256-PdMDDNTvcp34lE88wLz1TL/DfpfJNQlj/kbSw2ypzAc=')
        script.setAttribute('crossorigin', 'anonymous')
        document.head.appendChild(script)
      }
    }
  }
  customElements.define('ks-image-compare', KsImageCompare)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-newsletter"] && !window.DesignMode) return;
  try {
    
  if (Shopify.designMode) return

  // Create cookie function
  function createCookie (name, value, days) {
    let date, expires
    if (days) {
      date = new Date()
      date.setDate(date.getDate() + days)
      expires = '; expires=' + date.toUTCString()
    } else {
      expires = ''
    }
    document.cookie = name + '=' + value + expires + '; path=/'
  }

  const dialog = document.querySelector('#j1-newsletter-dialog')

  // Close dialog if clicked outside
  dialog.addEventListener('click', (event) => {
    const withinBoundaries = event.composedPath().includes(dialog.querySelector('.j1-dialog-inner'))

    if (!withinBoundaries) {
      dialog.close()
    }
  })

  // Close button
  dialog.querySelector('data-dialog-close')?.addEventListener('click', (event) => {
    event.preventDefault()
    dialog.close()
  })

  // Show the dialog if url contains (www.mystore.com/?j1-newsletter-popup)
  if (window.location.href.includes('j1-newsletter-popup')) {
    dialog.showModal()
    return
  }

  // Do not show the dialog if the cookie is still present (config from settings)
  if (document.cookie.indexOf('j1-newsletter-popup') > -1) {
    return
  }

  (async () => {
    // Show the dialog on page load after some time has passed (config from settings)
    await new Promise(resolve => setTimeout(resolve, Number(dialog.dataset.configDelay) * 1000))

    // Create a cookie so that we don't show the dialog for some time (config from settings)
    createCookie('j1-newsletter-popup', true, Number(dialog.dataset.configDaysToWait))

    dialog.showModal()
  })();

  } catch(e) { console.error(e); }
})();
})();
